// import { DocumentTypeEnum } from "../../../configuration-hub/data/enums/configuration-hub.enum";
import { DocumentType } from "modules/processing-hub/data/enums";
export interface DocumentTypeState {
  selectedDocumentType: string;
  documentTypeOptions: Array<{
    value: string;
    label: string;
  }>;
  loading: boolean;
  error: string[] | null;
}

// Load persisted document type from sessionStorage
const getPersistedDocumentType = (): string => {
  try {
    const persisted = sessionStorage.getItem("selectedDocumentType");
    return persisted || ""; // Default to empty string to show all
  } catch (error) {
    console.error("Error loading document type from sessionStorage:", error);
    return "";
  }
};

export const initialDocumentTypeState: DocumentTypeState = {
  selectedDocumentType: getPersistedDocumentType(),
  documentTypeOptions: [],
  loading: false,
  error: null
};
